import { decodeBoatClass } from '@/network/decoders'
import CtlClass from '@/orm/models/CtlClass'
import { AxiosRepository } from '@pinia-orm/axios'

export default class CtlClassesRepo extends AxiosRepository<CtlClass> {
    use = CtlClass

    transformApiData(data: any[]) {
        return data.flatMap((line) => {
            if (!Object.hasOwn(line, 'classes'))
                return []

            const ctlId = parseInt(line.id)

            return line.classes.map((element) => ({
                id: ctlId + '_' + decodeBoatClass(element.classId) + '_' + parseInt(element.weight) + '_'
                    + (Object.hasOwn(element, 'eventType') ? String(element.eventType) : ''),
                ctlId: ctlId,
                boatClassId: decodeBoatClass(element.classId),
                weight: parseInt(element.weight),
                shortcut: String(element.shortcut),
                eventType: Object.hasOwn(element, 'eventType') ? String(element.eventType) : '',
                className: Object.hasOwn(element, 'className') ? element.className : null,
                publicLicenseExceptionType: (Object.hasOwn(element, 'publicLicenseExceptionType')
                        && element.publicLicenseExceptionType !== null)
                    ? parseInt(element.publicLicenseExceptionType)
                    : null,
                days: (Object.hasOwn(element, 'days') && element.days !== null) ? parseInt(element.days) : null,
                startDate: (Object.hasOwn(element, 'startDate') && element.startDate !== null)
                    ? new Date(element.startDate)
                    : null,
            }))
        })
    }

    saveFromApiData(data: any[]) {
        return this.save(this.transformApiData(data))
    }
}
